import React from "react";

import LegalDocument from "./LegalDocument";

const SECTIONS = [
  {
    heading: "Acceptance of Terms",
    body: "By accessing or using our services, you agree to comply with and be bound by these Terms and Conditions.",
  },
  {
    heading: "Services Provided",
    body: "We offer a range of IT solutions, including but not limited to software development, cybersecurity, cloud services, and IT consulting.",
  },
  {
    heading: "User Responsibilities",
    list: [
      "Provide accurate information during registration.",
      "Use our services only for lawful purposes.",
      "Not engage in any conduct that may harm our services or other users.",
    ],
  },
  {
    heading: "Payment Terms",
    list: [
      "Payment for services must be made in accordance with the pricing outlined on our website or in specific agreements or in commercials shared with customers.",
      "Late payments may incur additional fees.",
    ],
  },
  {
    heading: "Confidentiality",
    body: "We are committed to protecting your privacy. All user information will be handled in accordance with our Privacy Policy.",
  },
  {
    heading: "Limitation of Liability",
    body: "We are not liable for any indirect, incidental, or consequential damages arising from the use of our services.",
  },
  {
    heading: "Termination",
    body: "We reserve the right to terminate or suspend access to our services at our discretion, without prior notice.",
  },
  {
    heading: "Changes to Terms",
    body: "We may update these Terms and Conditions periodically. Users will be notified of significant changes.",
  },
  {
    heading: "Governing Law",
    body: "These Terms and Conditions shall be governed by the laws as described by the Government of India.",
  },
  {
    heading: "Contact Information",
    body: "For questions or concerns regarding these Terms and Conditions, please contact us or refer to the commercials shared or discussed with you.",
  },
];

function TermsAndConditions() {
  return (
    <LegalDocument
      id="TermsConditions"
      title="Terms and Conditions"
      subtitle="Applies to all services provided by New Age Services."
      sections={SECTIONS}
    />
  );
}

export default TermsAndConditions;
